import { useState } from 'react';
import { CheckoutForm } from '../ui/CheckoutForm';
import { Box } from '@/components/Box/Box';
import { CheckoutLoaderWrapper } from '../styles';
import { LayoutSpinner } from '@/bundle/Layouts/styles';
import { SinglePaymentCheckoutProvider } from './SinglePaymentCheckoutProvider';
import { Notification } from '@/components/Notification/Notification';
import { useCatchStripeInitError } from '../useCatchStripeInitError';
import { UNEXPECTED_ERROR_MESSAGE } from '@/const/shared';

type SinglePaymentCheckoutWidgetType = {
  wiresQuantity: number;
  onSuccess: () => void;
};

export const SinglePaymentCheckoutWidget = ({ wiresQuantity, onSuccess }: SinglePaymentCheckoutWidgetType) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useCatchStripeInitError((error) => {
    setError(error);
    setLoading(false);
  });

  const errorHandler = () => {
    setLoading(false);
    setError(UNEXPECTED_ERROR_MESSAGE);
  };

  return (
    <Box position='relative' height='100%'>
      {error && (
        <Notification variant='error' marginBottom='16px'>
          {error}
        </Notification>
      )}
      <SinglePaymentCheckoutProvider wiresQuantity={wiresQuantity} onError={errorHandler}>
        <CheckoutForm
          paymentType='singlePayment'
          loading={loading}
          onLoadingEnd={() => setLoading(false)}
          onSuccess={onSuccess}
        />
      </SinglePaymentCheckoutProvider>

      {loading && (
        <CheckoutLoaderWrapper>
          <LayoutSpinner />
        </CheckoutLoaderWrapper>
      )}
    </Box>
  );
};
